// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IndySoft API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AppendMeasurementDto } from '../models';
// @ts-ignore
import type { CompleteCalibrationRequestDto } from '../models';
// @ts-ignore
import type { CompleteCalibrationResponseDto } from '../models';
// @ts-ignore
import type { CreateDcRuntimeDto } from '../models';
// @ts-ignore
import type { DcRuntimeViewModel } from '../models';
// @ts-ignore
import type { DcRuntimeViewModelPaginatedResponse } from '../models';
// @ts-ignore
import type { UpdateDcRuntimeDto } from '../models';
/**
 * DcRuntimeApi - axios parameter creator
 * @export
 */
export const DcRuntimeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} woDetailGlobalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDcRuntimeByWoDetailWoDetailGlobalIdGet: async (woDetailGlobalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'woDetailGlobalId' is not null or undefined
            assertParamExists('apiDcRuntimeByWoDetailWoDetailGlobalIdGet', 'woDetailGlobalId', woDetailGlobalId)
            const localVarPath = `/api/dc-runtime/by-wo-detail/{woDetailGlobalId}`
                .replace(`{${"woDetailGlobalId"}}`, encodeURIComponent(String(woDetailGlobalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDcRuntimeGet: async (pageNumber?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dc-runtime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CompleteCalibrationRequestDto} [completeCalibrationRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDcRuntimeIdCompletePost: async (id: string, completeCalibrationRequestDto?: CompleteCalibrationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDcRuntimeIdCompletePost', 'id', id)
            const localVarPath = `/api/dc-runtime/{id}/complete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeCalibrationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDcRuntimeIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDcRuntimeIdGet', 'id', id)
            const localVarPath = `/api/dc-runtime/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {AppendMeasurementDto} [appendMeasurementDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDcRuntimeIdMeasurementPost: async (id: string, appendMeasurementDto?: AppendMeasurementDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDcRuntimeIdMeasurementPost', 'id', id)
            const localVarPath = `/api/dc-runtime/{id}/measurement`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appendMeasurementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDcRuntimeDto} [updateDcRuntimeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDcRuntimeIdPut: async (id: string, updateDcRuntimeDto?: UpdateDcRuntimeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDcRuntimeIdPut', 'id', id)
            const localVarPath = `/api/dc-runtime/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDcRuntimeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDcRuntimeIdResetSyncPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDcRuntimeIdResetSyncPost', 'id', id)
            const localVarPath = `/api/dc-runtime/{id}/reset-sync`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateDcRuntimeDto} [createDcRuntimeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDcRuntimePost: async (createDcRuntimeDto?: CreateDcRuntimeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dc-runtime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDcRuntimeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DcRuntimeApi - functional programming interface
 * @export
 */
export const DcRuntimeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DcRuntimeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} woDetailGlobalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDcRuntimeByWoDetailWoDetailGlobalIdGet(woDetailGlobalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DcRuntimeViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDcRuntimeByWoDetailWoDetailGlobalIdGet(woDetailGlobalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DcRuntimeApi.apiDcRuntimeByWoDetailWoDetailGlobalIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDcRuntimeGet(pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DcRuntimeViewModelPaginatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDcRuntimeGet(pageNumber, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DcRuntimeApi.apiDcRuntimeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {CompleteCalibrationRequestDto} [completeCalibrationRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDcRuntimeIdCompletePost(id: string, completeCalibrationRequestDto?: CompleteCalibrationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteCalibrationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDcRuntimeIdCompletePost(id, completeCalibrationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DcRuntimeApi.apiDcRuntimeIdCompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDcRuntimeIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DcRuntimeViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDcRuntimeIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DcRuntimeApi.apiDcRuntimeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {AppendMeasurementDto} [appendMeasurementDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDcRuntimeIdMeasurementPost(id: string, appendMeasurementDto?: AppendMeasurementDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DcRuntimeViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDcRuntimeIdMeasurementPost(id, appendMeasurementDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DcRuntimeApi.apiDcRuntimeIdMeasurementPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDcRuntimeDto} [updateDcRuntimeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDcRuntimeIdPut(id: string, updateDcRuntimeDto?: UpdateDcRuntimeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DcRuntimeViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDcRuntimeIdPut(id, updateDcRuntimeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DcRuntimeApi.apiDcRuntimeIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDcRuntimeIdResetSyncPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DcRuntimeViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDcRuntimeIdResetSyncPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DcRuntimeApi.apiDcRuntimeIdResetSyncPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateDcRuntimeDto} [createDcRuntimeDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDcRuntimePost(createDcRuntimeDto?: CreateDcRuntimeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DcRuntimeViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDcRuntimePost(createDcRuntimeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DcRuntimeApi.apiDcRuntimePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DcRuntimeApi - factory interface
 * @export
 */
export const DcRuntimeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DcRuntimeApiFp(configuration)
    return {
        /**
         * 
         * @param {DcRuntimeApiApiDcRuntimeByWoDetailWoDetailGlobalIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDcRuntimeByWoDetailWoDetailGlobalIdGet(requestParameters: DcRuntimeApiApiDcRuntimeByWoDetailWoDetailGlobalIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DcRuntimeViewModel> {
            return localVarFp.apiDcRuntimeByWoDetailWoDetailGlobalIdGet(requestParameters.woDetailGlobalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DcRuntimeApiApiDcRuntimeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDcRuntimeGet(requestParameters: DcRuntimeApiApiDcRuntimeGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DcRuntimeViewModelPaginatedResponse> {
            return localVarFp.apiDcRuntimeGet(requestParameters.pageNumber, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DcRuntimeApiApiDcRuntimeIdCompletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDcRuntimeIdCompletePost(requestParameters: DcRuntimeApiApiDcRuntimeIdCompletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompleteCalibrationResponseDto> {
            return localVarFp.apiDcRuntimeIdCompletePost(requestParameters.id, requestParameters.completeCalibrationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DcRuntimeApiApiDcRuntimeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDcRuntimeIdGet(requestParameters: DcRuntimeApiApiDcRuntimeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DcRuntimeViewModel> {
            return localVarFp.apiDcRuntimeIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DcRuntimeApiApiDcRuntimeIdMeasurementPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDcRuntimeIdMeasurementPost(requestParameters: DcRuntimeApiApiDcRuntimeIdMeasurementPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DcRuntimeViewModel> {
            return localVarFp.apiDcRuntimeIdMeasurementPost(requestParameters.id, requestParameters.appendMeasurementDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DcRuntimeApiApiDcRuntimeIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDcRuntimeIdPut(requestParameters: DcRuntimeApiApiDcRuntimeIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DcRuntimeViewModel> {
            return localVarFp.apiDcRuntimeIdPut(requestParameters.id, requestParameters.updateDcRuntimeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DcRuntimeApiApiDcRuntimeIdResetSyncPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDcRuntimeIdResetSyncPost(requestParameters: DcRuntimeApiApiDcRuntimeIdResetSyncPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DcRuntimeViewModel> {
            return localVarFp.apiDcRuntimeIdResetSyncPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DcRuntimeApiApiDcRuntimePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDcRuntimePost(requestParameters: DcRuntimeApiApiDcRuntimePostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DcRuntimeViewModel> {
            return localVarFp.apiDcRuntimePost(requestParameters.createDcRuntimeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DcRuntimeApi - interface
 * @export
 * @interface DcRuntimeApi
 */
export interface DcRuntimeApiInterface {
    /**
     * 
     * @param {DcRuntimeApiApiDcRuntimeByWoDetailWoDetailGlobalIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DcRuntimeApiInterface
     */
    apiDcRuntimeByWoDetailWoDetailGlobalIdGet(requestParameters: DcRuntimeApiApiDcRuntimeByWoDetailWoDetailGlobalIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DcRuntimeViewModel>;

    /**
     * 
     * @param {DcRuntimeApiApiDcRuntimeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DcRuntimeApiInterface
     */
    apiDcRuntimeGet(requestParameters?: DcRuntimeApiApiDcRuntimeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DcRuntimeViewModelPaginatedResponse>;

    /**
     * 
     * @param {DcRuntimeApiApiDcRuntimeIdCompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DcRuntimeApiInterface
     */
    apiDcRuntimeIdCompletePost(requestParameters: DcRuntimeApiApiDcRuntimeIdCompletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompleteCalibrationResponseDto>;

    /**
     * 
     * @param {DcRuntimeApiApiDcRuntimeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DcRuntimeApiInterface
     */
    apiDcRuntimeIdGet(requestParameters: DcRuntimeApiApiDcRuntimeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DcRuntimeViewModel>;

    /**
     * 
     * @param {DcRuntimeApiApiDcRuntimeIdMeasurementPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DcRuntimeApiInterface
     */
    apiDcRuntimeIdMeasurementPost(requestParameters: DcRuntimeApiApiDcRuntimeIdMeasurementPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DcRuntimeViewModel>;

    /**
     * 
     * @param {DcRuntimeApiApiDcRuntimeIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DcRuntimeApiInterface
     */
    apiDcRuntimeIdPut(requestParameters: DcRuntimeApiApiDcRuntimeIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DcRuntimeViewModel>;

    /**
     * 
     * @param {DcRuntimeApiApiDcRuntimeIdResetSyncPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DcRuntimeApiInterface
     */
    apiDcRuntimeIdResetSyncPost(requestParameters: DcRuntimeApiApiDcRuntimeIdResetSyncPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DcRuntimeViewModel>;

    /**
     * 
     * @param {DcRuntimeApiApiDcRuntimePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DcRuntimeApiInterface
     */
    apiDcRuntimePost(requestParameters?: DcRuntimeApiApiDcRuntimePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DcRuntimeViewModel>;

}

/**
 * Request parameters for apiDcRuntimeByWoDetailWoDetailGlobalIdGet operation in DcRuntimeApi.
 * @export
 * @interface DcRuntimeApiApiDcRuntimeByWoDetailWoDetailGlobalIdGetRequest
 */
export interface DcRuntimeApiApiDcRuntimeByWoDetailWoDetailGlobalIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DcRuntimeApiApiDcRuntimeByWoDetailWoDetailGlobalIdGet
     */
    readonly woDetailGlobalId: string
}

/**
 * Request parameters for apiDcRuntimeGet operation in DcRuntimeApi.
 * @export
 * @interface DcRuntimeApiApiDcRuntimeGetRequest
 */
export interface DcRuntimeApiApiDcRuntimeGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DcRuntimeApiApiDcRuntimeGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof DcRuntimeApiApiDcRuntimeGet
     */
    readonly pageSize?: number
}

/**
 * Request parameters for apiDcRuntimeIdCompletePost operation in DcRuntimeApi.
 * @export
 * @interface DcRuntimeApiApiDcRuntimeIdCompletePostRequest
 */
export interface DcRuntimeApiApiDcRuntimeIdCompletePostRequest {
    /**
     * 
     * @type {string}
     * @memberof DcRuntimeApiApiDcRuntimeIdCompletePost
     */
    readonly id: string

    /**
     * 
     * @type {CompleteCalibrationRequestDto}
     * @memberof DcRuntimeApiApiDcRuntimeIdCompletePost
     */
    readonly completeCalibrationRequestDto?: CompleteCalibrationRequestDto
}

/**
 * Request parameters for apiDcRuntimeIdGet operation in DcRuntimeApi.
 * @export
 * @interface DcRuntimeApiApiDcRuntimeIdGetRequest
 */
export interface DcRuntimeApiApiDcRuntimeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DcRuntimeApiApiDcRuntimeIdGet
     */
    readonly id: string
}

/**
 * Request parameters for apiDcRuntimeIdMeasurementPost operation in DcRuntimeApi.
 * @export
 * @interface DcRuntimeApiApiDcRuntimeIdMeasurementPostRequest
 */
export interface DcRuntimeApiApiDcRuntimeIdMeasurementPostRequest {
    /**
     * 
     * @type {string}
     * @memberof DcRuntimeApiApiDcRuntimeIdMeasurementPost
     */
    readonly id: string

    /**
     * 
     * @type {AppendMeasurementDto}
     * @memberof DcRuntimeApiApiDcRuntimeIdMeasurementPost
     */
    readonly appendMeasurementDto?: AppendMeasurementDto
}

/**
 * Request parameters for apiDcRuntimeIdPut operation in DcRuntimeApi.
 * @export
 * @interface DcRuntimeApiApiDcRuntimeIdPutRequest
 */
export interface DcRuntimeApiApiDcRuntimeIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof DcRuntimeApiApiDcRuntimeIdPut
     */
    readonly id: string

    /**
     * 
     * @type {UpdateDcRuntimeDto}
     * @memberof DcRuntimeApiApiDcRuntimeIdPut
     */
    readonly updateDcRuntimeDto?: UpdateDcRuntimeDto
}

/**
 * Request parameters for apiDcRuntimeIdResetSyncPost operation in DcRuntimeApi.
 * @export
 * @interface DcRuntimeApiApiDcRuntimeIdResetSyncPostRequest
 */
export interface DcRuntimeApiApiDcRuntimeIdResetSyncPostRequest {
    /**
     * 
     * @type {string}
     * @memberof DcRuntimeApiApiDcRuntimeIdResetSyncPost
     */
    readonly id: string
}

/**
 * Request parameters for apiDcRuntimePost operation in DcRuntimeApi.
 * @export
 * @interface DcRuntimeApiApiDcRuntimePostRequest
 */
export interface DcRuntimeApiApiDcRuntimePostRequest {
    /**
     * 
     * @type {CreateDcRuntimeDto}
     * @memberof DcRuntimeApiApiDcRuntimePost
     */
    readonly createDcRuntimeDto?: CreateDcRuntimeDto
}

/**
 * DcRuntimeApi - object-oriented interface
 * @export
 * @class DcRuntimeApi
 * @extends {BaseAPI}
 */
export class DcRuntimeApi extends BaseAPI implements DcRuntimeApiInterface {
    /**
     * 
     * @param {DcRuntimeApiApiDcRuntimeByWoDetailWoDetailGlobalIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DcRuntimeApi
     */
    public apiDcRuntimeByWoDetailWoDetailGlobalIdGet(requestParameters: DcRuntimeApiApiDcRuntimeByWoDetailWoDetailGlobalIdGetRequest, options?: RawAxiosRequestConfig) {
        return DcRuntimeApiFp(this.configuration).apiDcRuntimeByWoDetailWoDetailGlobalIdGet(requestParameters.woDetailGlobalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DcRuntimeApiApiDcRuntimeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DcRuntimeApi
     */
    public apiDcRuntimeGet(requestParameters: DcRuntimeApiApiDcRuntimeGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DcRuntimeApiFp(this.configuration).apiDcRuntimeGet(requestParameters.pageNumber, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DcRuntimeApiApiDcRuntimeIdCompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DcRuntimeApi
     */
    public apiDcRuntimeIdCompletePost(requestParameters: DcRuntimeApiApiDcRuntimeIdCompletePostRequest, options?: RawAxiosRequestConfig) {
        return DcRuntimeApiFp(this.configuration).apiDcRuntimeIdCompletePost(requestParameters.id, requestParameters.completeCalibrationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DcRuntimeApiApiDcRuntimeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DcRuntimeApi
     */
    public apiDcRuntimeIdGet(requestParameters: DcRuntimeApiApiDcRuntimeIdGetRequest, options?: RawAxiosRequestConfig) {
        return DcRuntimeApiFp(this.configuration).apiDcRuntimeIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DcRuntimeApiApiDcRuntimeIdMeasurementPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DcRuntimeApi
     */
    public apiDcRuntimeIdMeasurementPost(requestParameters: DcRuntimeApiApiDcRuntimeIdMeasurementPostRequest, options?: RawAxiosRequestConfig) {
        return DcRuntimeApiFp(this.configuration).apiDcRuntimeIdMeasurementPost(requestParameters.id, requestParameters.appendMeasurementDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DcRuntimeApiApiDcRuntimeIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DcRuntimeApi
     */
    public apiDcRuntimeIdPut(requestParameters: DcRuntimeApiApiDcRuntimeIdPutRequest, options?: RawAxiosRequestConfig) {
        return DcRuntimeApiFp(this.configuration).apiDcRuntimeIdPut(requestParameters.id, requestParameters.updateDcRuntimeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DcRuntimeApiApiDcRuntimeIdResetSyncPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DcRuntimeApi
     */
    public apiDcRuntimeIdResetSyncPost(requestParameters: DcRuntimeApiApiDcRuntimeIdResetSyncPostRequest, options?: RawAxiosRequestConfig) {
        return DcRuntimeApiFp(this.configuration).apiDcRuntimeIdResetSyncPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DcRuntimeApiApiDcRuntimePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DcRuntimeApi
     */
    public apiDcRuntimePost(requestParameters: DcRuntimeApiApiDcRuntimePostRequest = {}, options?: RawAxiosRequestConfig) {
        return DcRuntimeApiFp(this.configuration).apiDcRuntimePost(requestParameters.createDcRuntimeDto, options).then((request) => request(this.axios, this.basePath));
    }
}

